export enum PaymentTermTiming {
    FromShipping = 'from-shipping',
    FromInvoice = 'from-invoice',
    FromArrival = 'from-arrival',
    FromDueDate = 'from-dueDate',
}
